import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ChatService {
    constructor(private http: HttpClient) {}

    getChatNotes(filter: any) {
        return this.http.post<any>(`api:///Chat/GetChatNote`, filter);
    }

    getDifferentChatNotes(filter: any) {
        return this.http.post<any>(`api:///Chat/GetDifferentChatNotes`, filter);
    }

    getChatTypes() {
        return this.http.get<any>(`api:///Chat/GetChatTypes`);
    }

    submitNewChatNote(model: any) {
        return this.http.post(`api:///Chat/SaveNewChatNote`, model);
    }

    getChatNoteDetails(chatNoteId: number) {
        return this.http.get<any>(`api:///Chat/GetNoteDetails/${chatNoteId}`);
    }

    submitReply(model: any) {
        return this.http.post(`api:///Chat/SaveReply`, model);
    }

    editNote(model: any) {
        return this.http.post(`api:///Chat/EditChatNote`, model);
    }

    removeChatNote(model: any) {
        return this.http.post(`api:///Chat/RemoveChatNote`, model);
    }

    downloadAttachment(attachmentId) {
        return this.http.get(`api:///Chat/DownloadAttachment/${attachmentId}`);
    }

    getUnreadCounts() {
        return this.http.get<any>(`api:///Chat/GetUnreadCounts`);
    }

    markChatNotesAsRead(chatNoteIds: any) {
        return this.http.post(`api:///Chat/MarkAsRead`, chatNoteIds);
    }

    markChatNoteAsUnread(chatNoteId: number) {
        return this.http.post(`api:///Chat/MarkAsUnread`, chatNoteId);
    }
}
